export default "__VITE_ASSET__DIbvLpBT__"